<template>
    <select v-model="estadoSelecionado" :disabled="disabled" class="form-control">
        <option value selected disabled>Selecione</option>
        <option v-for="(estado, index) in estados" :key="index" :value="estado">{{ estado}}</option>
    </select>
</template>
<script>
import LocalidadesService from "../../service/LocalidadesService.js";

export default {
	props: [ "disabled", "value" ],
	data() {
		return {
			estadoSelecionado: this.value,
			estados: "",
		};
	},
	watch: {
		estadoSelecionado(newValue, oldValue) {
			this.$emit("estadoSelecionado", newValue);
		},
	},
	created() {
		this.buscarEstados();
	},
	methods: {
		buscarEstados() {
			let estadosLocais = [];
			LocalidadesService.listarEstados()
				.then((res) => {
					estadosLocais = res.data;
					this.estados = estadosLocais.map(e => e.nome);
				}).catch(err => console.log(err));
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/SelectEstados.vue